// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-btn[data-v-39dfc49f]:not(.v-btn--active):focus::before,.v-btn[data-v-39dfc49f]:not(.v-btn--active):hover::before{opacity:0}", ""]);
// Exports
module.exports = exports;
